/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'
import cXxYnImg from 'assets/images/cXxYn.png'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - JWT(JSON Web Token)</h2>
    <img className={styles.img} src={cXxYnImg} alt="JWT" />
    <section className={styles.subsection}>
      <h3 className={styles.h3}>1.1 - Дополнительные материалы</h3>
      <ul className={styles.list}>
        <li className={styles.list__item}>
          <a className={styles.link} href="https://jwt.io/introduction/" target="_blank">
            Introduction to JSON Web Tokens
          </a>
        </li>
        <li className={styles.list__item}>
          <a
            className={styles.link}
            href="https://gist.github.com/zmts/802dc9c3510d79fd40f9dc38a12bccfc"
            target="_blank"
          >
            Про токены, JSON Web Tokens (JWT), аутентификацию и авторизацию
          </a>
        </li>
      </ul>
    </section>
  </section>
))
